import { createStore } from 'redux';
import { DefaultRootState } from 'react-redux';
import { Organization, OrganizationDetail, TenantServiceItem } from './types/organization';

import { UserData, OrganizationServiceItem } from './types/user';
import { RoleItemTable, SiteData, SiteDetail } from './types/siteData';
import { TenantItem } from './types/tenant';
import { siteData, siteDetailData, roleData } from './views/sites/site-mock';
export interface ApplicationState extends DefaultRootState {
  sidebarShow: boolean | '' | 'responsive' | undefined;
  logoutTimerId: any;
  cognitoUser: any;
  organizationDetail: OrganizationDetail;
  organization: Organization;
  userData: UserData;
  tenantService: TenantServiceItem[];
  tenantsInfo: TenantItem[];
  organizationService: OrganizationServiceItem[];
  siteData: SiteData;
  msgModal: {
    show: boolean;
    textMsg: string;
  };
  userDetail: {
    organization_id: string;
    organization_name: string;
    user_id: string;
    user_name: string;
    email: string;
    tenant_id: string;
    admin_flag: boolean;
    services_list: OrganizationServiceItem[];
  };
  siteDetail: SiteDetail;
  roleData: RoleItemTable[];
}
const initialState: ApplicationState = {
  logoutTimerId: null,
  sidebarShow: 'responsive',
  cognitoUser: null,
  organizationDetail: {
    organization_id: '',
    organization_name: '',
    service: [],
  },
  organization: {
    tenant_id: '',
    tenant_name: '',
    organization_list: [],
  },
  userData: {
    organization_id: '',
    organization_name: '',
    user_list: [],
  },
  userDetail: {
    organization_id: '',
    organization_name: '',
    user_id: '',
    user_name: '',
    email: '',
    tenant_id: '',
    admin_flag: false,
    services_list: [],
  },
  tenantService: [],
  tenantsInfo: [],
  organizationService: [],
  siteData:{
    organization_id:"",
    organization_name:"",
    site_list:[]
  },
  // siteData: siteData,
  siteDetail: {
    organization_id: '',
    organization_name: '',
    site_id: '',
    site_name: '',

    access_point_id: '',
    acceptance_id: '',
    area_id: '',
    group_id: '',
    peakcut_power_threshold: 0,
    is_feedback: false,
    low_high_pressure: 0,
    temperature_region_id: '',
    market_region_id: '',
    latitude: '',
    longitude: '',
    category: 0,
    platform_code: 0,
  },
  // siteDetail: siteDetailData,
  // roleData:[],
  roleData: roleData,
  msgModal: {
    show: false,
    textMsg: '',
  },
};

const changeState = (state = initialState, { type, ...rest }: Record<string, any>) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    case 'clear':
      return initialState;
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
